import { isValidEmail } from '@/lib/email';
import { isProbablyPhone } from '@/lib/phone';
import type { LoadPeopleSearchParams } from '@/store/people/actions/people';

export function makeSearchParam(
  value: string,
): LoadPeopleSearchParams | undefined {
  value = value.trim();
  if (!value) {
    return undefined;
  }

  const at = value.indexOf('@');
  if (at !== -1) {
    if (!isValidEmail(value)) {
      return undefined;
    }

    return {
      type: 'email',
      value,
    };
  }

  if (isProbablyPhone(value)) {
    return {
      type: 'phone',
      value,
    };
  }

  return {
    type: 'name',
    value,
  };
}
